// extracted by mini-css-extract-plugin
export default {"contact":"homePage_contact__J8d0F","address":"homePage_address__gds5m","showcase":"homePage_showcase__-qo0l","homepage":"homePage_homepage__6kFU-"};